import { ComponentEvent } from './component-event'
import { SSWTransaction } from 'common/ssw'
import { DataLayerEventName } from 'common/helpers/DataLayerEventName'

export interface BreachEventProps {
    /* What paywall method was implemented ie freemium vs metered */
    paywallType: 'freemium' | 'metered'
    /* lead in depth - how many paragraphs were shown in the lead in */
    leadDepth: number
    /* breach screen creative name */
    creative: string
    breachScreenType: 'inline'
    /* breach screen pop up method - user vs auto pop up vs pop under vs inline */
    popupMethod: 'auto'
    /* The deal in the breach screen, deal code	 */
    deal: string
    /* Upcoming breach notification - ie you have two stories left */
    upcomingNotify?: number
    /* Subscription price point */
    pricepoint: number[]
}

type BreachCompleteEventProps = BreachEventProps & SSWTransaction

export interface BreachAvailableEvent extends ComponentEvent<BreachEventProps> {
    type: DataLayerEventName.breachScreenAvailable
}

export interface BreachClickEvent extends ComponentEvent<BreachEventProps> {
    type: DataLayerEventName.breachScreenClick
}

export interface BreachCompleteEvent extends ComponentEvent<BreachCompleteEventProps> {
    type: DataLayerEventName.breachScreenComplete
}

interface BreachBaseGTMProps extends Omit<BreachEventProps, 'pricepoint'> {
    transactionAffiliation: 'The West'
    pricepoint: string
}

interface Transaction {
    sku: string
    name: string
    price: number
    quantity: 1
}

interface BreachCompleteGTMProps
    extends BreachBaseGTMProps,
        Omit<SSWTransaction, 'productSku' | 'productName'> {
    transactionProducts: Transaction[]
    transactionShipping: 0
}

export type BreachEvent = BreachAvailableEvent | BreachCompleteEvent | BreachClickEvent

export function toBreachBaseEventShape(props: BreachEventProps): BreachBaseGTMProps {
    return {
        ...props,
        transactionAffiliation: 'The West',
        pricepoint: props.pricepoint.join(','),
    }
}

export function toBreachCompleteEventShape(
    props: BreachCompleteEventProps
): BreachCompleteGTMProps {
    const {
        transactionId,
        transactionTotal,
        transactionTax,
        productSku,
        productName,
        pricepoint,
        ...breachProps
    } = props

    return {
        ...breachProps,
        transactionId,
        pricepoint: pricepoint.join(','),
        transactionAffiliation: 'The West',
        transactionTotal,
        transactionTax,
        transactionShipping: 0,
        transactionProducts: [
            {
                sku: productSku,
                name: productName,
                price: transactionTotal,
                quantity: 1,
            },
        ],
    }
}
